import * as yup from 'yup';
import { AgencyType } from '@/entities/auth/agency-type.enum';
import { UserRole } from '@/entities/auth/user-role.enum';

export const partnerSubTypeSchema = yup.object({
  name: yup.object({
    de: yup.string().required(),
    en: yup.string().required(),
  }),
  role: yup
    .mixed<UserRole.AGENCY | UserRole.COMPANY>()
    .oneOf([UserRole.AGENCY, UserRole.COMPANY])
    .required(),
  type: yup
    .mixed<AgencyType>()
    .nullable()
    .when('role', {
      is: UserRole.AGENCY,
      then: (schema) => schema.oneOf(Object.values(AgencyType)).required(),
      otherwise: (schema) => schema.optional().nullable(),
    }),
});
